import { ArrowRightToLine } from 'lucide-react';
import { forwardRef } from 'react';
import { cn } from '~/util';
import { BaseLevel } from '~/util/types/levels';

export type NewLevelPosition = Pick<BaseLevel, 'name' | 'position' | 'status'>;

export const ListEditPreview = ({
    above,
    middle,
    below,
}: {
    above?: NewLevelPosition | null;
    middle: NewLevelPosition;
    below?: NewLevelPosition | null;
}) => {
    return (
        <div className="w-2/3 flex flex-col items-center gap-1 mx-auto">
            {above && <PreviewLevelLink {...above} />}
            <div className="flex items-center w-full gap-1">
                <ArrowRightToLine className="text-primary" />
                <PreviewLevelLink {...middle} />
            </div>
            {below && <PreviewLevelLink {...below} />}
        </div>
    );
};

export const PreviewLevelLink = forwardRef<HTMLDivElement, NewLevelPosition>(
    function LinkRow({ name, position, status, ...props }, ref) {
        if (!name) return null;
        return (
            <div
                ref={ref}
                className={cn(
                    'p-1.5 rounded-md my-0.5',
                    'flex w-full items-center transition-colors cursor-pointer',
                    'bg-background-light hover:bg-secondary-light',
                    'focus:bg-primary focus:text-primary-foreground outline-none',
                )}
                {...props}
            >
                <p className="w-30 text-center clamp-[text-xl-2xl-clamp] lg:clamp-[text-sm-lg-clamp]">
                    {status == 'MainList' ? `#${position}` : `- (#${position})`}
                </p>
                <p className="text-start clamp-[text-xl-2xl-clamp] lg:clamp-[text-sm-lg-clamp] truncate ">
                    {name}{' '}
                </p>
            </div>
        );
    },
);
PreviewLevelLink.displayName = 'PreviewLevelLink';
